import React from 'react';
import {
  Layout,
  CardSection,
  Grid,
  GridRow,
  GridColumn,
  useBreakpoint,
  CondensedSmall,
  Card,
  Gutter,
} from '@axiom/ui';

export const DefaultLayout: React.FC<{
  name?: string;
  sideImageUrl?: string;
  children: React.ReactNode;
}> = ({ name, sideImageUrl, children }) => {
  const { isLargeScreen } = useBreakpoint();
  return (
    <Grid name={name}>
      <GridRow>
        <GridColumn largeScreenWidth={2} />
        <GridColumn largeScreenWidth={8} smallScreenWidth={12}>
          <Card>
            <CardSection
              name="CLIENT_LOGIN_TWO_COLUMN_LAYOUT_SECTION"
              background={
                isLargeScreen
                  ? {
                      image: sideImageUrl,
                      size: 'cover',
                      position: 'center center',
                    }
                  : {}
              }
            >
              <Grid>
                <GridRow>
                  <GridColumn largeScreenWidth={6} smallScreenWidth={12}>
                    <Layout
                      position="center stretch"
                      direction="vertical"
                      stretched
                    >
                      <Gutter bottom="48px" only="largeScreen" />
                      <Gutter bottom="24px" only="tablet" />
                      {children}
                      <Gutter bottom="48px" only="largeScreen" />
                      <Gutter bottom="24px" only="tablet" />
                    </Layout>
                  </GridColumn>
                </GridRow>
              </Grid>
            </CardSection>
            <CardSection background="light blue">
              <CondensedSmall className="text-align-center">
                © {new Date().getFullYear()} Axiom Law. Axiom's{' '}
                <a
                  href="https://www.axiomlaw.com/axiom-terms-of-use"
                  rel="noreferrer"
                  target="_blank"
                >
                  Terms of Use
                </a>{' '}
                and{' '}
                <a
                  href="https://www.axiomlaw.com/privacy-notice"
                  rel="noreferrer"
                  target="_blank"
                >
                  Privacy Notice
                </a>
                .
              </CondensedSmall>
            </CardSection>
          </Card>
        </GridColumn>
        <GridColumn largeScreenWidth={2} />
      </GridRow>
    </Grid>
  );
};
